var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{class:_vm.valid === false ? 'red--text': ''},[_vm._v(_vm._s(_vm.field.label))]),_c('vue-tel-input',{staticStyle:{"margin-bottom":"13px"},attrs:{"valid-characters-only":"","value":_vm.newValue,"default-country":"FR","mode":"international","preferred-countries":['FR'],"input-options":{
      placeholder:'000 000 000'
    }},on:{"input":($event) => { _vm.newValue = $event},"validate":($event) => { _vm.valid = $event.valid}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }